module.exports = __webpack_public_path__ + "img/facebook.96de97f4.png";